"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIsSmallSizeType = void 0;
var sizeTypes_1 = require("../constants/sizeTypes");
var checkIsSmallSizeType = function (size) { return (size === sizeTypes_1.SIZE_TYPES.small); };
exports.checkIsSmallSizeType = checkIsSmallSizeType;
